/* src/app/components/home-component/home-component.css */
.button-row {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}
.home-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 11px 16px;
  border-radius: 999px;
  border: 1px solid rgba(212, 175, 55, 0.3);
  letter-spacing: 0.04em;
  transition:
    transform 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}
.home-action.primary-btn {
  background:
    linear-gradient(
      135deg,
      var(--gold) 0%,
      var(--gold-bright) 100%);
  color: #1b120d;
  border-color: rgba(240, 215, 122, 0.85);
}
.home-action.secondary-btn {
  background: rgba(255, 255, 255, 0.05);
  color: var(--ink);
}
.home-action:hover {
  transform: translateY(-1px);
}
.home-action.secondary-btn:hover {
  background: rgba(212, 175, 55, 0.12);
  border-color: rgba(212, 175, 55, 0.42);
}
.login-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--gold-bright);
  font-weight: bold;
}
.login-link:hover {
  transform: translateY(-1px);
  background: rgba(212, 175, 55, 0.2);
  border-color: rgba(240, 215, 122, 0.7);
}
/*# sourceMappingURL=home-component.css.map */
